/**
 * Converts a dollar amount to integer cents.
 *
 * @example dollarsToCents(12.34) // 1234
 * @example dollarsToCents(0.1)   // 10
 */
export default function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100);
}
